export enum AssignedFileNumberType {
  SENATE = 'Senátní',
  PLENARY = 'Plenární',
}
